export default {
    formId: 'createExpressCheckinForm', //'checkoutForm',
    formField: {
      code: {
        name: 'code',
        label: 'Codigo Reserva*',
        requiredErrorMsg: 'El codigo de reserva es requerido.'
      },
      adults: {
        name: 'adults',
        label: 'Cantidad Adultos*',
        requiredErrorMsg: 'La cantidad de adultos es requerido.'
      },
      minors: {
        name: 'minors',
        label: 'Cantidad Menores*',
        requiredErrorMsg: 'La cantidad de menores es requerido.'
      },
      arrival: {
        name: 'arrival',
        label: 'Fecha Llegada*',
        requiredErrorMsg: 'La fecha llegada es requerida.'
      },
      departure: {
        name: 'departure',
        label: 'Fecha Salida*',
        requiredErrorMsg: 'La fecha salida es requerida.'
      },
      bussines: {
        name: 'bussines',
        label: '¿Reserva Empresarial?',
        requiredErrorMsg: 'La fecha salida es requerida.'
      },
    }
};
